import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
import { CustomRoleInput, CustomRoleView } from './schemas.js';
/**
 * Custom-role registry (FR-ADM-02 extension). Built-in roles have no routes:
 * they are code (`BUILTIN_ROLE_PERMISSIONS`), so the console reads them from
 * the contracts package directly — there is nothing to fetch or edit.
 */
export const adminRolesRoutes = {
    roles: { method: 'GET', path: '/admin/roles', response: z.array(CustomRoleView) },
    createRole: {
        method: 'POST',
        path: '/admin/roles',
        body: CustomRoleInput,
        response: CustomRoleView,
    },
    updateRole: {
        method: 'PUT',
        path: '/admin/roles/:roleId',
        body: CustomRoleInput,
        response: CustomRoleView,
    },
    deleteRole: {
        method: 'DELETE',
        path: '/admin/roles/:roleId',
        body: AdminActionInput,
        response: z.object({ id: z.string(), deleted: z.literal(true) }),
    },
};
//# sourceMappingURL=routes.js.map